import React from "react";
import styles from "./unit-input-and-popover.module.scss";
import { UnitsListPopover } from "@src/components/molecules/units-list-popover/units-list-popover";
import { UnitObject } from "@common/types/tree-types";
import {
  UnitInputAndPopoverHookReturnTypes,
  useUnitInputAndPopoverHook,
} from "./use-unit-input-and-popover-hook";
import { useI18N } from "@src/language/language-context";
interface UnitInputAndPopoverPropTypes {
  unit: UnitObject;
  popoverOnClickCallback: (value: UnitObject) => void;
  useHook?: (
    unit: UnitObject,
    popoverOnClickCallback: (value: UnitObject) => void,
  ) => UnitInputAndPopoverHookReturnTypes;
}

const cssClassName = "unit-input-and-popover";

export const UnitInputAndPopover = ({
  unit,
  popoverOnClickCallback,
  useHook = useUnitInputAndPopoverHook,
}: UnitInputAndPopoverPropTypes) => {
  const i18n = useI18N();
  const {
    popoverRef,
    inputValue,
    inputOnChange,
    matchingUnitsArray,
    handleClickOnPopover,
  } = useHook(unit, popoverOnClickCallback);

  const texts = {
    labelText: i18n("modules.unitInputAndPopover.labelText"),
    placeholderText: i18n("modules.unitInputAndPopover.placeholderText"),
  };

  return (
    <div
      /* this ref condition is necessary to avoid the ref related hook (the one which closs the popover) to act before the onBlur function */
      ref={inputValue === "" ? null : popoverRef}
      className={styles[cssClassName]}
    >
      <div className={styles[`${cssClassName}__label`]}>{texts.labelText}</div>
      <input
        className={styles[`${cssClassName}__input`]}
        placeholder={texts.placeholderText}
        value={inputValue}
        onChange={(e) => inputOnChange(e.target.value)}
        onBlur={(e) => {
          if (e.target.value === "") {
            handleClickOnPopover(null);
          }
        }}
      />
      <div className={styles[`${cssClassName}__popover-wrapper`]}>
        {matchingUnitsArray && matchingUnitsArray.length > 0 && (
          <UnitsListPopover
            popoverOnClickCallback={handleClickOnPopover}
            matchingUnitsArray={matchingUnitsArray}
          />
        )}
      </div>
    </div>
  );
};
